export const DEPARTMENT_REQUEST = "DEPARTMENT_REQUEST";
export const DEPARTMENT_SUCCESS = "DEPARTMENT_SUCCESS";
export const DEPARTMENT_FAIL = "DEPARTMENT_FAIL";
export const DEPARTMENT_CLEAR_ERRORS = "DEPARTMENT_CLEAR_ERRORS";
